// extracted by mini-css-extract-plugin
export default {"Card":"Card_Card__NKVET","Card-appear":"Card_Card-appear__Pv9XK"};